import Tab from './tab-icon.svg';

export default {
  Tab,
};
